import { useMemo } from 'react';

import { PatientUniversalStatusCode } from '~/lib/constants/patients.constants';
import { universalStatusMapper } from '~/lib/util/patient.util';
import { useGetUniversalStatusesEnumQuery } from '~/store/services/enumerations';

export interface UseGetPatientStatus {
  style: PatientStatusStyles;
  status: string;
}

const useGetPatientStatus = ({
  patient,
}: {
  patient: Patient;
}): UseGetPatientStatus => {
  const { data: universalStatusEnums } = useGetUniversalStatusesEnumQuery();

  const { universalStatusCode } = patient ?? {};

  const computedPatientStatus = useMemo<PatientUniversalStatusCode>(
    () =>
      (universalStatusCode as PatientUniversalStatusCode) ||
      PatientUniversalStatusCode.UNKNOWN,
    [universalStatusCode],
  );

  const style = useMemo<PatientStatusStyles>(
    () => universalStatusMapper[computedPatientStatus],
    [computedPatientStatus],
  );
  const status = useMemo<string>(() => {
    if (universalStatusEnums) {
      const e = universalStatusEnums.find(
        (x) => x.code === computedPatientStatus,
      );
      return e ? e.description : computedPatientStatus;
    }
    return computedPatientStatus;
  }, [universalStatusEnums, computedPatientStatus]);

  return { status, style };
};

export default useGetPatientStatus;
